import { styled } from "@vitality-ds/system";
import BaseButtonStyles from "../Button/primitives/styles/BaseButton.styles";
import BaseTypographyStyles from "../Typography/styles/BaseTypography.styles";
import BaseLinkStyles from "./styles/BaseLink.styles";
export var BaseLink = styled("a", BaseTypographyStyles, BaseLinkStyles);
export var BaseLinkButton = styled("a", BaseButtonStyles);